<template>
  <div id="app">
    <!-- <router-link to="/slimtest">slimtest</router-link>
    <router-link to="/slimtest2">slimtest2</router-link> -->

    <router-view />
  </div>
</template>


<script>

import config from "@/config"

export default {
  created(){

  },
  name: "app",
  data() {
    return {
      isRouterAlive: true
    };
  },
  components:{
    
  }
};
</script>
